
<template>
  <div>
    <v-row align='center' justify='end' class="pa-3 black--text">
      <span class="title text-capitalize" v-if="$refs.calendar">
        {{ $refs.calendar.title }}
      </span>
      <v-spacer></v-spacer>

      <v-btn
        text small
        class="ma-2"
        @click="setToday"
      >
        <v-icon left >mdi-calendar-today</v-icon>
        Hoje
      </v-btn>
      <template v-if="type=='day'">
        <!-- <v-spacer></v-spacer> -->
        <v-btn
          text small
          class="ma-2"
          @click="setMonthly"
        >
          <v-icon left>mdi-calendar-month</v-icon>
          mensal
        </v-btn>
      </template>
      <v-btn
        icon
        class="ma-2"
        @click="$refs.calendar.prev()"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn
        icon
        class="ma-2"
        @click="$refs.calendar.next()"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-row>
    <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
    <v-calendar
      color="primary"
      ref="calendar"
      v-model="value"
      :weekdays="weekday"
      :type="type"
      :events="tasks"
      :event-overlap-mode="mode"
      @click:date="viewDay"
      :event-overlap-threshold="30"
      :event-color="getEventColor"
      @change="getEvents"
      :event-text-color="'black'"
      @click:event="showEvent"
      event-start="start_at"
      event-end="due_at"
      interval-height="0"
    ></v-calendar>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'TheCalendar',
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  data() {
    const month = new Date().getMonth();
    const year = new Date().getFullYear();
    return {
      masks: {
        weekdays: 'WWW',
      },
      type: 'month',
      types: ['month', 'week', 'day', '4day'],
      mode: 'column',
      modes: ['stack', 'column'],
      weekday: [0, 1, 2, 3, 4, 5, 6],
      weekdays: [
        { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
        { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
        { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
        { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      ],
      value: '',
      events: [],
      colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
      names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],

      tasks: [],
      loading: false,
    };

  },
  methods: {
    setToday () {
      this.value = ''
    },
    setMonthly () {
      this.type = 'month'
    },

    viewDay ({ date }) {
      this.value = date
      this.type = 'day'
    },

    showEvent ({ nativeEvent, event }) {
      if (this.$route.name == 'Agenda'){
        this.$router.push({name: 'AgendaShowTask', params: {id: event.id}})
      } else {
        this.$router.push({name: 'ShowTask', params: {id: event.id}})
      }
    },
    getEvents({ start, end }){
      // console.log('tasks?', {start, end});
      if (start){
        start = this.$dayjs(start.date).startOf('month').format()
      } else {
        start = this.$dayjs().startOf('month').format()
      }
      if (end){
        end = this.$dayjs(end.date).endOf('month').format()
      } else {
        end = this.$dayjs().endOf('month').format()
      }
      // console.log('tasks?', {start, end});

      this.loading = true
      let filter = {
        searches: {
          // users_id_eq: this.profile.id,
          use_type_eq: 1, //official
          due_at_gt: start,
          due_at_lteq: end,
        },
        // sorts: [
        //   'due_at asc'
        // ]
      }
      Api.Task.index(filter).then(r=> r.data).then(d => {
        this.tasks = [...d.map(d=> {
          let {start_at, due_at, ...t} = d
          return {...t, start_at: start_at.substring(0,10), due_at: due_at.substring(0,10)}
        })]
      }).finally(()=> {
        setTimeout(() => {
          this.loading = false
        }, 1200);
      })
    },
    getEventsFake ({ start, end }) {
      // console.log({start, end});
      const events = []

      const min = new Date(`${start.date}T00:00:00`)
      const max = new Date(`${end.date}T23:59:59`)
      const days = (max.getTime() - min.getTime()) / 86400000
      const eventCount = 10// this.rnd(days, days + 20)

      for (let i = 0; i < eventCount; i++) {
        const allDay = this.rnd(0, 3) === 0
        const firstTimestamp = this.rnd(min.getTime(), max.getTime())
        const first = new Date(firstTimestamp - (firstTimestamp % 900000))
        const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000
        const second = new Date(first.getTime() + secondTimestamp)

        events.push({
          name: this.names[this.rnd(0, this.names.length - 1)],
          start_at: first,
          due_at: second,
          color: this.colors[this.rnd(0, this.colors.length - 1)],
          timed: false,
        })
      }

      this.events = events
    },
    getEventColor (event) {
      return event.json_attributes? event.json_attributes.color : event.color
    },
    // getEventColor2 (event) {
    //   return event.json_attributes.color
    // },
    rnd (a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },

    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  mounted () {
    // console.log('montou')
    this.getEvents({});
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  width: 0px;
}

::-webkit-scrollbar-track {
  display: none;
}

::v-deep .custom-calendar.vc-container {
  --day-border: 1px solid #b8c2cc;
  --day-border-highlight: 1px solid #b8c2cc;
  --day-width: 90px;
  --day-height: 90px;
  --weekday-bg: #f8fafc;
  --weekday-border: 1px solid #eaeaea;

  border-radius: 0;
  width: 100%;

   .vc-header {
    background-color: #f1f5f8;
    padding: 10px 0;
  }
   .vc-weeks {
    padding: 0;
  }
   .vc-weekday {
    background-color: var(--weekday-bg);
    border-bottom: var(--weekday-border);
    border-top: var(--weekday-border);
    padding: 5px 0;
  }
   .vc-day {
    padding: 0 5px 3px 5px;
    text-align: left;
    height: var(--day-height);
    min-width: var(--day-width);
    background-color: white;
    .weekday-1,
    .weekday-7 {
      background-color: #eff8ff;
    }
    :not(.on-bottom) {
      border-bottom: var(--day-border);
      .weekday-1 {
        border-bottom: var(--day-border-highlight);
      }
    }
    :not(.on-right) {
      border-right: var(--day-border);
    }
  }
   .vc-day-dots {
    margin-bottom: 5px;
  }
}

// asdfa
</style>